import React, { useState } from 'react';
import { Divider } from 'antd';
import { RightOutlined } from '@ant-design/icons';

import { translate } from '@portal/services/i18n';

import Certificate from '@portal/assets/svg/onboarding-icons/ic_certificate.svg?react';

import OnboardingUserPhotoModal from '../OnboardingUserPhotoModal/OnboardingUserPhotoModal';
import useReduxState from '@portal/hooks/useReduxState';

interface IProps {
  setFileSelected: (value: File) => void;
  nameDocument: string;
}

const CustomDocument = ({ setFileSelected, nameDocument }: IProps) => {
  const [modal, setModal] = useState(false);
  const [fileSelectedModal, setFileSelectedModal] = useState(null);
  const onFileChange = (file) => {
    if (
      file.target.files[0]?.type !== 'image/png' &&
      file.target.files[0]?.type !== 'image/jpeg'
    ) {
      return;
    }
    setFileSelected(file.target.files[0]);
    setFileSelectedModal(file.target.files[0]);
  };
  const {
    onboarding: { saveDocument },
  } = useReduxState();

  return (
    <>
      {nameDocument && !fileSelectedModal && !saveDocument ? (
        <div className="action-display" onClick={() => setModal(true)}>
          <div className="action-display__action">
            <div className="action-display__action__options">
              <Certificate
                width={25}
                height={25}
                className="action-display__action__options__icon"
              />
              <div className="action-display__action__options__container">
                <p className="action-display__action__options__title-document">
                  {nameDocument}
                </p>
                <p className="action-display__action__options__text">
                  {translate(
                    'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.LABEL'
                  )}
                </p>
              </div>
            </div>

            <span>
              <RightOutlined
                style={{
                  color: 'black',
                  fontSize: 20,
                }}
              />
            </span>
          </div>
          <Divider />
        </div>
      ) : null}
      {modal ? (
        <OnboardingUserPhotoModal
          onCancel={() => setModal(false)}
          onFileChange={onFileChange}
          visible={modal}
          fileSelected={fileSelectedModal}
        />
      ) : null}
    </>
  );
};

export default CustomDocument;
